export default "__VITE_ASSET__DgXkeYGw__"